import { Link, type LinkProps } from '@trg/tlw-ui-component';
import { tlwTwMerge } from '@trg/utils';
import {
  useBuriedPoint,
  type BuriedPoint,
  type BuriedPointProduct,
} from '../../../common';
import { useMemo } from 'react';

export type EventItemProps = LinkProps;

export function EventItem({ className, ...props }: EventItemProps) {
  const { tagAttributes } = useBuriedPoint('ad', {
    data: useMemo<Partial<BuriedPoint>>(
      () => ({
        ad_creative_slot: 'homepage',
        ad_creative_name: '跑馬燈',
        ad_promotion_id: props.href,
        ad_promotion_name: props.children?.toString(),
        items: [
          {
            item_id: props.href,
            item_name: props.children?.toString(),
          } as BuriedPointProduct,
        ],
      }),
      [props.children, props.href]
    ),
    enabled: Boolean(props.href),
  });

  return (
    <Link
      className={tlwTwMerge(
        'tlw-txt-zh-head-6 tlw-text-txt-core tlw-truncate',
        className
      )}
      {...props}
      {...tagAttributes}
    />
  );
}
